var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "c-button c-button--icons",
      class: { "c-button--active": _vm.selected },
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.toggle },
    },
    [
      _vm.icon
        ? _c("img", { staticClass: "c-button__icon", attrs: { src: _vm.icon } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.icon
        ? _c("span", { staticClass: "c-button__icon" }, [_vm._v("Aa")])
        : _vm._e(),
      _vm._v("\n    " + _vm._s(_vm.text) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }